module.exports = __webpack_public_path__ + "static/media/gif.4a7060e8.gif";